import request from '@/utils/request';

// 在线乘客数量
export function passenger_online(query) {
  return request({
    url: '/netcar/api/dashboard/passenger_online',
    method: 'GET',
    data: query
  })
}

// 获取运力数据信息
export function passenger_register(query) {
  return request({
    url: '/netcar/api/dashboard/passenger_register',
    method: 'GET',
    data: query
  })
}

// 获取支付占比
export function driver_online(query) {
  return request({
    url: '/netcar/api/dashboard/driver_online',
    method: 'GET',
    data: query
  })
}

// 获取最新五条数据列表
export function driver_register(query) {
  return request({
    url: '/netcar/api/dashboard/driver_register',
    method: 'GET',
    data: query
  })
}

// 订单统计
export function driver_online_time(query) {
  return request({
    url: '/netcar/api/dashboard/driver_online_time',
    method: 'GET',
    data: query
  })
}
// 订单统计
export function passenger_count(query) {
  return request({
    url: '/netcar/api/dashboard/passenger_count',
    method: 'GET',
    data: query
  })
}
